import { render } from "./ruzhi.vue?vue&type=template&id=0a0c5efc&scoped=true"
import script from "./ruzhi.vue?vue&type=script&lang=js"
export * from "./ruzhi.vue?vue&type=script&lang=js"

import "./ruzhi.vue?vue&type=style&index=0&id=0a0c5efc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0c5efc"]])

export default __exports__